// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tools-container {
    padding: 0 24px 24px 0;
    margin: 0;
    width: 100%;
}

.tools-header {
    background-color: #fff;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e7eb;
}

.tools-title {
    font-size: 20px;
    font-weight: 600;
    color: #1e3c72;
    margin: 0;
}

.tools-content {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e7eb;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #1e3c72;
}

.help-text {
    display: block;
    font-size: 12px;
    color: #666;
    font-weight: normal;
    margin-top: 4px;
}

textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    font-family: monospace;
    font-size: 14px;
    line-height: 1.4;
    resize: vertical;
    background-color: #f9fafb;
    transition: all 0.2s ease;
    min-height: 120px;
}

textarea:focus {
    outline: none;
    border-color: #2a5298;
    box-shadow: 0 0 0 2px rgba(42, 82, 152, 0.1);
    background-color: #fff;
}

.form-actions {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
}

.btn-primary {
    background-color: #2a5298;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-primary:hover {
    background-color: #1e3c72;
}

.btn-primary:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
}

.message {
    padding: 12px 16px;
    border-radius: 6px;
    margin-bottom: 16px;
    font-size: 14px;
}

.message.success {
    background-color: #f0fdf4;
    color: #166534;
    border: 1px solid #bbf7d0;
}

.message.error {
    background-color: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

@media (max-width: 640px) {
    .tools-container {
        padding: 16px;
    }
    
    .tools-header,
    .tools-content {
        padding: 16px;
    }
    
    .btn-primary {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/styles/tools.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".tools-container {\n    padding: 0 24px 24px 0;\n    margin: 0;\n    width: 100%;\n}\n\n.tools-header {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 16px 20px;\n    margin-bottom: 24px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e5e7eb;\n}\n\n.tools-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #1e3c72;\n    margin: 0;\n}\n\n.tools-content {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e5e7eb;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n    color: #1e3c72;\n}\n\n.help-text {\n    display: block;\n    font-size: 12px;\n    color: #666;\n    font-weight: normal;\n    margin-top: 4px;\n}\n\ntextarea {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    font-family: monospace;\n    font-size: 14px;\n    line-height: 1.4;\n    resize: vertical;\n    background-color: #f9fafb;\n    transition: all 0.2s ease;\n    min-height: 120px;\n}\n\ntextarea:focus {\n    outline: none;\n    border-color: #2a5298;\n    box-shadow: 0 0 0 2px rgba(42, 82, 152, 0.1);\n    background-color: #fff;\n}\n\n.form-actions {\n    margin-top: 24px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.btn-primary {\n    background-color: #2a5298;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-primary:hover {\n    background-color: #1e3c72;\n}\n\n.btn-primary:disabled {\n    background-color: #94a3b8;\n    cursor: not-allowed;\n}\n\n.message {\n    padding: 12px 16px;\n    border-radius: 6px;\n    margin-bottom: 16px;\n    font-size: 14px;\n}\n\n.message.success {\n    background-color: #f0fdf4;\n    color: #166534;\n    border: 1px solid #bbf7d0;\n}\n\n.message.error {\n    background-color: #fef2f2;\n    color: #991b1b;\n    border: 1px solid #fecaca;\n}\n\n@media (max-width: 640px) {\n    .tools-container {\n        padding: 16px;\n    }\n    \n    .tools-header,\n    .tools-content {\n        padding: 16px;\n    }\n    \n    .btn-primary {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
